import type { ComponentProps } from 'react';

import { NumberField as UadNumberField } from '@iconik-io/uad';

type UadNumberFieldProps = ComponentProps<typeof UadNumberField>;

import { useFieldContext } from '../app_form_context';
import { getFieldErrorMessage } from '../get_field_error_message';

export type NumberFieldProps = Omit<
  UadNumberFieldProps,
  'name' | 'value' | 'onChange' | 'onBlur' | 'isInvalid' | 'errorMessage'
>;

export function NumberField(props: NumberFieldProps) {
  const field = useFieldContext<number>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <UadNumberField
      name={field.name}
      value={field.state.value}
      onBlur={field.handleBlur}
      onChange={field.handleChange}
      isInvalid={isInvalid}
      errorMessage={
        isInvalid ? getFieldErrorMessage(field.state.meta.errors) : undefined
      }
      {...props}
    />
  );
}
